import Joi from '@hapi/joi'

export const routeEmployeeDetailsReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    date: Joi.string().invalid("").label("Date").required().messages({
        "any.invalid": `Please select Date`,
        "any.required": `Date required`
    }),
}